import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import NetworkCall from "network/networkCall";
import Request from "network/request";

export const notificationSlice = createSlice({
  //fetch data={1:simple call,2:searched call 3:no call}
  name: "notifications",
  initialState: {
    notificationList: null,
    notificationCount: 0,
    hasMore: false,
    allread: false,
  },
  reducers: {
    saveNotifications: (state, action) => {
      state.notificationList = [...action.payload, ...state.notificationList];
    },
    saveFirstNotifications: (state, action) => {
      state.notificationList = [...action.payload];
    },
    saveNotificationsAfter: (state, action) => {
      state.notificationList = [...state.notificationList, ...action.payload];
    },
    resetNotificationCount: (state, action) => {
      state.notificationCount = 0;
    },
    saveNotificationCount: (state, action) => {
      if (action.payload === "plus") {
        state.notificationCount = parseInt(state.notificationCount + 1);
        state.allread = true;
      } else {
        state.notificationCount = action.payload ? parseInt(action.payload) : 0;
      }
      // action.payload === "plus"
      //   ? (state.notificationCount = parseInt(state.notificationCount + 1))
      //   : (state.notificationCount = action.payload
      //       ? parseInt(action.payload)
      //       : 0);
    },
    saveHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    saveAllRead: (state, action) => {
      state.allread = action.payload;
    },
  },
});
export const fetchNotificationList = (body, status) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(
        Request.getNotifications(body),
        false
      );
      const newData = response?.data?.data;
      dispatch(saveNotificationCount(response?.data?.totalRecords));

      let flag = false;

      response?.data?.data?.map((e) => {
        return !e?.isRead ? (flag = true) : e;
      });
      dispatch(saveAllRead(flag));
      if (newData === undefined) {
        status
          ? dispatch(saveNotifications([]))
          : dispatch(saveFirstNotifications([]));
        dispatch(saveHasMore(false));
      } else {
        if (status) {
          dispatch(saveNotificationsAfter(newData));
          dispatch(saveHasMore(true));
        } else {
          newData.length < 20
            ? dispatch(saveHasMore(false))
            : dispatch(saveHasMore(true));
          dispatch(saveFirstNotifications(newData));
        }
      }
      // dispatch(saveFirstNotifications(newData === undefined ? [] : newData));
    } catch (error) {
      // setFieldErrorsFromServer(error, form, values);
      console.log({ error });
      //  message.error("error occured");
    }
  };
};

export const resetCountApi = (body, status) => {
  return async (dispatch, getState) => {
    try {
      dispatch(resetNotificationCount());

      const response = await NetworkCall.fetch(
        Request.resetCountNotify(body),
        false
      );
      // const newData = response?.data?.data;

      // dispatch(saveFirstNotifications(newData === undefined ? [] : newData));
    } catch (error) {
      // setFieldErrorsFromServer(error, form, values);
      console.log({ error });
      //  message.error("error occured");
    }
  };
};

export const {
  saveNotifications,
  savePusherNotifications,
  saveNotificationCount,
  saveFirstNotifications,
  resetNotificationCount,
  saveNotificationsAfter,
  saveHasMore,
  saveAllRead,
} = notificationSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const allNotifications = (state) => state.notifications.notificationList;
export const CountNotification = (state) =>
  state.notifications.notificationCount;
export const NotificationHasMore = (state) => state.notifications.hasMore;
export const readAllFlag = (state) => state.notifications.allread;

export default notificationSlice.reducer;
